import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { Grid } from 'semantic-ui-react';
import {
  getFormSyncErrors,
  formValueSelector,
  getFormValues,
} from 'redux-form';
import PropTypes from 'prop-types';
import moment from 'moment';
import _ from 'lodash';

import { YesNoDialog, LoadingPage, NotificationDialog } from 'Components';
import { Filter, Main } from 'Containers';
import { getIsDirty } from 'Common/Selectors/DirtySelector';
import {
  BidGroupEnum,
  BidPriceEnum,
  FifoEnum,
  FilterEnum,
  ItemMaintenanceEnum,
  TabItemMaintenanceEnum,
  TransactionDetailsEnum,
  UpdateBidPriceDetailsEnum,
} from 'Common/FieldEnum';
import {
  ITEM_MAINTENANCE_DETAIL_FORM_NAME,
  ITEM_MAINTENANCE_BID_PRICE_FORM_NAME,
  ITEM_MAINTENANCE_TRANSACTION_DETAILS_FORM_NAME,
} from 'Common/FormEnum';
import { createToast, errorToast, toastType } from 'Common/ToastHelper';
import { resetForm, submitForm } from 'State/forms/actions';
import { clearGridPreferenceSubmitError } from 'State/gridPreference/actions';
import { setTableStates } from 'Common/UserSettings/state/actions';
import { clearTableSavedState } from 'Common/FormHelper';
import { getTableStates } from 'Common/UserSettings/helpers/helper';
import { TableNamesEnum } from 'Common/Constants/Enumeration/TableEnum';
import {
  PrintGroupByTypeEnum,
  DropDownEnum,
} from 'Common/Constants/Enumeration/CommonEnum';
import { resetDirty } from 'State/dirtyTracking/actions';
import { DATE_FORMAT_FOR_UI, DATE_FORMAT_FOR_SERVER } from 'Common/Constants';

import {
  getAcctCategoryForCurrentSite,
  getBidGroupForCurrentSite,
  getItemGroupForCurrentSite,
  getVendorForCurrentSite,
} from 'State/filters/actions';
import { BracketTypeEnum } from 'Common/Constants/Enumeration/ItemMaintenanceEnum';

import {
  ActiveStatusEnum,
  addPropertiesForSave,
  basicURL,
  bidDatesMaxValidation,
  bidDatesValidation,
  EditItemHeaderRowButtons,
  getInitialValues,
  getWareHouseWarningBooleanValue,
  INITIAL_VALUES,
  isQtyPerUnitChanged,
  makeBidPricePayload,
  NewItemHeaderRowButtons,
} from '../helpers';
import FIFO from '../components/FIFO';
import ItemDetailsForm from '../components/ItemDetails';
import TransactionDetails from '../components/TransactionDetails';
import { clearError, saveItems } from './../state/addEditItem/actions';
import {
  getBidPriceDetails,
  getControlInfo,
  resetBidPriceData,
  resetPayload,
  clearBidPriceData,
  clearBidPriceError,
  updateGridFormFields,
  updateBidPriceDetails,
  resetWarehouseWarning,
  clearControlInfo,
  getWarehouseWarning,
} from '../state/updateBidPriceDetails/actions';
import * as actions from '../state/addEditItem/actions';
import { getTaxGroupSetup } from './../../taxgroupsetup/state/actions';
import BidPrice from '../containers/BidPrice';
import {
  getItems,
  updateSelectedRowIndex,
} from '../state/itemMaintenance/actions';
import HeaderRowButtonComponent from '../components/HeaderRowButton';

class AddEditModal extends Component {
  static path = '/itemmaintenance/:id';
  static propTypes = {
    saveItems: PropTypes.func.isRequired,
    submitForm: PropTypes.func.isRequired,
    clearError: PropTypes.func.isRequired,
    clearGridPreferenceSubmitError: PropTypes.func.isRequired,
    resetForm: PropTypes.func.isRequired,
    getBidPriceDetails: PropTypes.func.isRequired,
    getAcctCategoryForCurrentSite: PropTypes.func.isRequired,
    getBidGroupForCurrentSite: PropTypes.func.isRequired,
    getItemGroupForCurrentSite: PropTypes.func.isRequired,
    getVendorForCurrentSite: PropTypes.func.isRequired,
    getTaxGroupSetup: PropTypes.func.isRequired,
    getItems: PropTypes.func.isRequired,
    setTableStates: PropTypes.func.isRequired,
    updateSelectedRowIndex: PropTypes.func.isRequired,
    getControlInfo: PropTypes.func.isRequired,
    resetBidPriceData: PropTypes.func.isRequired,
    resetPayload: PropTypes.func.isRequired,
    clearBidPriceData: PropTypes.func.isRequired,
    resetDirty: PropTypes.func.isRequired,
    clearBidPriceError: PropTypes.func.isRequired,
    updateGridFormFields: PropTypes.func.isRequired,
    updateBidPriceDetails: PropTypes.func.isRequired,
    resetWarehouseWarning: PropTypes.func.isRequired,
    clearControlInfo: PropTypes.func.isRequired,
    getWarehouseWarning: PropTypes.func.isRequired,
    fetching: PropTypes.bool.isRequired,
    itemDetails: PropTypes.array.isRequired,
    selectedBidRowIndex: PropTypes.number.isRequired,
    fetchFifoItemsError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    fetchingBidError: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    fetchingOnHandsError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    fetchingTransactionError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    fetchingAltItemsError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    gridPreferenceSubmitError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    itemDetailsError: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    bidGroupDataError: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    itemGroupDataError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    acctCategoryDataError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    vendorDataError: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    taxGroupSetupError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    printError: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    itemDetailBidPriceErrors: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    bidPriceDetailsLoadingError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    controlInfoLoadingError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    bidPriceSubmitError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    warehouseWarningLoadingError: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    submitError: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
    warehouseWarning: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
    bidPriceDetailsData: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    originalBidPriceData: PropTypes.oneOfType([
      PropTypes.object,
      PropTypes.array,
    ]),
    submitted: PropTypes.bool.isRequired,
    submittingItemDetails: PropTypes.bool.isRequired,
    gridPreferenceSubmitting: PropTypes.bool.isRequired,
    fetchingOnHands: PropTypes.bool.isRequired,
    allTableStates: PropTypes.object.isRequired,
    loadingBidPriceDetails: PropTypes.bool.isRequired,
    isSubmitting: PropTypes.bool.isRequired,
    deletedBidIds: PropTypes.array.isRequired,
    loadingWarehouseWarning: PropTypes.bool.isRequired,
  };

  static defaultProps = {
    fetchFifoItemsError: null,
    fetchingBidError: null,
    fetchingOnHandsError: null,
    fetchingTransactionError: null,
    fetchingAltItemsError: null,
    gridPreferenceSubmitError: null,
    itemDetailsError: null,
    bidGroupDataError: null,
    itemGroupDataError: null,
    acctCategoryDataError: null,
    vendorDataError: null,
    taxGroupSetupError: null,
    printError: null,
    itemDetailBidPriceErrors: null,
    bidPriceDetailsLoadingError: null,
    controlInfoLoadingError: null,
    bidPriceSubmitError: null,
    warehouseWarningLoadingError: null,
    submitError: null,
    warehouseWarning: null,
    bidPriceDetailsData: null,
    originalBidPriceData: null,
  };

  state = {
    headerInfo: TabItemMaintenanceEnum.Details,
    showDateConflictModal: false,
    showMaxBeginDateModal: false,
    showBidPriceModal: false,
    isSaveButtonClicked: false,
    showSaveClickedModal: false,
    showTabSwitchModal: false,
    itemDetailsValues: {
      [ItemMaintenanceEnum.ItemCode]: '',
      [ItemMaintenanceEnum.Description]: '',
      [ItemMaintenanceEnum.GTINNumber]: '',
      [FilterEnum.AlternateItemId]: 0,
      [FilterEnum.GroupId_Cat]: 0,
      [FilterEnum.GroupId_Bid]: 0,
      [FilterEnum.GroupId_Item]: 0,
      [FilterEnum.TaxGroupId]: 0,
      [ItemMaintenanceEnum.AllowPartialOrdering]: false,
      [ItemMaintenanceEnum.ActiveStatus]: true,
    },
    isFormDirty: false,
  };

  handleItemDetailFieldChange = (e, values, prevValue, fieldName) => {
    let obj;
    if (fieldName) {
      obj = { ...this.state.itemDetailsValues };
      obj[fieldName] = values;
      this.setState({
        itemDetailsValues: obj,
        isFormDirty: true,
      });
    } else {
      this.setState({
        itemDetailsValues: values,
        isFormDirty: true,
      });
    }
  };

  async componentDidMount() {
    const { id } = this.props.match.params;

    const {
      getOnHandItem,
      getAltItems,
      getBidGroupForCurrentSite,
      getItemGroupForCurrentSite,
      getAcctCategoryForCurrentSite,
      getTaxGroupSetup,
      getBidPriceDetails,
      getItems,
      resetDirty,
    } = this.props;
    if (+id) {
      await getOnHandItem(id);
      await getItems(id);
    }
    await Promise.all([
      getBidPriceDetails(id),
      getAltItems(0),
      getBidGroupForCurrentSite(BidGroupEnum.AllOnly),
      getItemGroupForCurrentSite(),
      getAcctCategoryForCurrentSite(),
      getTaxGroupSetup(),
    ]);
    resetDirty();
  }
  getRootUrl = () => {
    const { url } = this.props.match;
    return url.substring(0, url.lastIndexOf('/'));
  };

  onSaveClick = () => {
    const {
      bidPriceDetailsData,
      originalBidPriceData,
      selectedBidRowIndex,
      getWarehouseWarning,
    } = this.props;
    //skip for new item (item id is 0 for new item)
    if (+this.props.match.params.id) {
      const changedQtyPerUnit = isQtyPerUnitChanged(
        bidPriceDetailsData,
        originalBidPriceData,
        selectedBidRowIndex
      );
      const { QtyPerUnit, BidId } = bidPriceDetailsData.BidPriceDetails[
        selectedBidRowIndex
      ];
      if (+BidId && changedQtyPerUnit) {
        this.setState(
          {
            showSaveClickedModal: true,
          },
          () => {
            getWarehouseWarning(this.props.match.params.id, BidId, QtyPerUnit);
          }
        );
      } else {
        this.handleOnSaveClick();
      }
    } else {
      this.handleOnSaveClick();
    }
  };

  handleOnSaveClick = () => {
    const { bidPriceDetailsData } = this.props;
    if (
      +this.props.match.params.id &&
      bidPriceDetailsData &&
      !bidPriceDetailsData.BidPriceDetails.length
    ) {
      this.setState({
        showBidPriceModal: true,
      });
      return;
    }
    this.setState({
      isSaveButtonClicked: true,
      showSaveClickedModal: false,
    });
    this.completeSave();
  };
  onResetClick = () => {
    this.completeReset();
    this.setState({
      showDateConflictModal: false,
      showMaxBeginDateModal: false,
      showBidPriceModal: false,
      isSaveButtonClicked: false,
      showSaveClickedModal: false,
      showTabSwitchModal: false,
    });
    if (this.props.match.params.id) {
      this.props.resetBidPriceData(this.props.originalBidPriceData).then(() => {
        this.props.updateGridFormFields(
          this.props.bidPriceDetailsData.BidPriceDetails[0],
          0
        );
        if (
          this.props.bidPriceDetailsData &&
          this.props.bidPriceDetailsData.BidPriceDetails &&
          this.props.bidPriceDetailsData.BidPriceDetails.length
        ) {
          this.props.bidPriceDetailsData.BidPriceDetails[0].BidId &&
            this.props.getControlInfo(
              this.props.bidPriceDetailsData.BidPriceDetails[0].ItemId,
              this.props.bidPriceDetailsData.BidPriceDetails[0].BidId,
              0
            );
        }
        this.props.resetDirty();
      });
    }
  };
  completeReset = () => {
    this.props.resetForm(ITEM_MAINTENANCE_DETAIL_FORM_NAME);
    this.props.resetForm(ITEM_MAINTENANCE_BID_PRICE_FORM_NAME);
  };
  getMainProps = () => {
    const {
      submitting,
      isReadOnly,
      formHasErrors,
      submittingItemDetails,
      loadingWarehouseWarning,
      printLoading,
    } = this.props;

    const { headerInfo } = this.state;

    return {
      toolbox: {
        backButtonProps: {
          shown: true,
          path: this.getRootUrl(),
          disabled: submittingItemDetails || printLoading,
        },
        rightButtons: [
          {
            content:
              headerInfo === TabItemMaintenanceEnum.TransactionDetails
                ? 'Print'
                : 'Reset',
            disabled: submitting || isReadOnly || formHasErrors || printLoading,
            onClick:
              headerInfo === TabItemMaintenanceEnum.TransactionDetails
                ? this.print
                : this.onResetClick,
            loading: submittingItemDetails || printLoading,
          },
          {
            content: 'Save',
            disabled:
              submitting ||
              isReadOnly ||
              formHasErrors ||
              loadingWarehouseWarning ||
              printLoading,
            onClick: this.handleSubmit,
            loading: submittingItemDetails || printLoading,
          },
        ],
        shown: true,
      },
    };
  };

  print = () => {
    const {
      beginDT,
      endDT,
      adjustment,
      order,
      physical,
      receipt,
      transfer,
      usage,
    } = this.props;

    const { id } = this.props.match.params;

    const payload = {
      ItemId: id,
      FromDate: moment(beginDT).format(DATE_FORMAT_FOR_SERVER),
      ToDate: moment(endDT).format(DATE_FORMAT_FOR_SERVER),
      SelectAll: false,
      IsFIFO: false,
      GroupBy: null,
      TransactionType: {
        Adjustment: adjustment,
        Order: order,
        Physical: physical,
        Receipt: receipt,
        Transfer: transfer,
        Usage: usage,
      },
    };
    this.props.printReportData(payload);
  };

  componentDidUpdate(prevProps) {
    const {
      clearError,
      clearGridPreferenceSubmitError,
      clearBidPriceError,
      resetWarehouseWarning,
    } = this.props;
    if (
      errorToast(this.props, prevProps, 'submitError') ||
      errorToast(this.props, prevProps, 'printError') ||
      errorToast(this.props, prevProps, 'fetchingBidError') ||
      errorToast(this.props, prevProps, 'fetchingOnHandsError') ||
      errorToast(this.props, prevProps, 'fetchingTransactionError') ||
      errorToast(this.props, prevProps, 'fetchingAltItemsError') ||
      errorToast(this.props, prevProps, 'fetchFifoItemsError') ||
      errorToast(this.props, prevProps, 'preferenceJsonError') ||
      errorToast(this.props, prevProps, 'gridPreferenceSubmitError') ||
      errorToast(this.props, prevProps, 'itemDetailsError') ||
      errorToast(this.props, prevProps, 'bidGroupDataError') ||
      errorToast(this.props, prevProps, 'itemGroupDataError') ||
      errorToast(this.props, prevProps, 'acctCategoryDataError') ||
      errorToast(this.props, prevProps, 'vendorDataError') ||
      errorToast(this.props, prevProps, 'taxGroupSetupError') ||
      errorToast(this.props, prevProps, 'bidPriceDetailsLoadingError') ||
      errorToast(this.props, prevProps, 'controlInfoLoadingError') ||
      errorToast(this.props, prevProps, 'bidPriceSubmitError') ||
      errorToast(this.props, prevProps, 'warehouseWarningLoadingError')
    ) {
      clearError();
      clearBidPriceError();
      clearGridPreferenceSubmitError();
    } else if (this.props.submitted && !prevProps.submitted) {
      createToast(toastType.success, 'Success', 'Item has been saved', true);
      clearError();
      this.props.resetDirty();
    }
    if (this.props.warehouseWarning === DropDownEnum.EmptyString) {
      const {
        showSaveClickedModal,
        showTabSwitchModal,
        currentHeaderTab,
      } = this.state;
      showSaveClickedModal && this.handleOnSaveClick();
      showTabSwitchModal && this.handleSetHeaderTab(currentHeaderTab);
      resetWarehouseWarning();
    }
  }

  componentWillUnmount() {
    const { allTableStates, setTableStates } = this.props;
    // reset the bid price page to 1 if user click on back button
    const updateBidPriceDetailTableState =
      allTableStates[TableNamesEnum.UPDATE_BID_PRICE_DETAILS_TABLE];
    if (updateBidPriceDetailTableState && updateBidPriceDetailTableState.page) {
      updateBidPriceDetailTableState.page = 0;
    }
    updateBidPriceDetailTableState &&
      setTableStates({
        ...allTableStates,
        [TableNamesEnum.UPDATE_BID_PRICE_DETAILS_TABLE]: updateBidPriceDetailTableState,
      });
    this.clearTableSavedState();
    this.completeReset();
    this.props.clearBidPriceData();
    this.props.clearControlInfo();
  }

  clearTableSavedState = () => {
    const { history, allTableStates, setTableStates } = this.props;
    clearTableSavedState(history, basicURL, allTableStates, setTableStates, [
      TableNamesEnum.ITEM_MAINTENANCE_TABLE,
      TableNamesEnum.UPDATE_BID_PRICE_DETAILS_TABLE,
      TableNamesEnum.FIFO_TABLE,
      TableNamesEnum.TRANSACTION_DETAIL_TABLE,
      TableNamesEnum.ITEM_DETAIL_TABLE,
    ]);
  };
  resetScroll = () => this.props.scrollMainTo(0, 0);

  handleItemDetailSubmit = values => {
    //note that even though this is called by the form's onSubmit, it doesn't
    //do anything - this method is only used by handleSubmit
    let payload = { ...values };

    const {
      match: {
        params: { id },
      },
      itemDetails,
    } = this.props;

    if (+id) {
      const itemDetail = _.get(itemDetails, 0);
      payload = addPropertiesForSave(payload, itemDetail, id);
    } else {
      payload[ItemMaintenanceEnum.ActiveStatus] = values[
        ItemMaintenanceEnum.ActiveStatus
      ]
        ? ActiveStatusEnum.Active
        : ActiveStatusEnum.Inactive;
    }

    return payload;
  };

  handleItemBidPriceSubmit = values => {
    //note that even though this is called by the form's onSubmit, it doesn't
    //do anything - this method is only used by handleSubmit

    const {
      match: {
        params: { id },
      },
      bidPriceDetailsData,
      deletedBidIds,
    } = this.props;

    let data = [];
    let payload = {
      ItemId: id,
      BidPriceDetails: [],
      DeletedBidIds: [],
    };

    if (bidPriceDetailsData && bidPriceDetailsData.BidPriceDetails) {
      const foundDateConflict = bidDatesValidation(
        bidPriceDetailsData.BidPriceDetails
      );
      const foundMaxBeginDate = bidDatesMaxValidation(
        bidPriceDetailsData.BidPriceDetails
      );
      if (foundMaxBeginDate) {
        this.setState({
          showMaxBeginDateModal: foundMaxBeginDate,
        });
        return;
      }
      if (foundDateConflict) {
        this.setState({
          showDateConflictModal: foundDateConflict,
        });
        return;
      }
      data = bidPriceDetailsData.BidPriceDetails.filter(item => {
        return item.modified;
      });
    }
    if ((data && data.length) || (deletedBidIds && deletedBidIds.length)) {
      payload = makeBidPricePayload(id, data, deletedBidIds);
    }

    return payload;
  };

  handleSubmit = async () => {
    const {
      match: {
        params: { id },
      },
      itemDetailErrors,
      itemDetailValues,
      itemBidPriceErrors,
      itemBidPriceValues,
    } = this.props;

    //navigate to the tab that contains the form with errors
    if (Object.keys(itemDetailErrors).length) {
      this.setState({ headerInfo: TabItemMaintenanceEnum.Details });
      return;
    } else if (Object.keys(itemBidPriceErrors).length) {
      this.setState({ headerInfo: TabItemMaintenanceEnum.BidPrice });
      return;
    }

    //build final object to submit
    const BidPriceSaveModel = this.handleItemBidPriceSubmit(itemBidPriceValues);

    const saveObject = {
      ...this.handleItemDetailSubmit(itemDetailValues),
      BidPriceSaveModel,
    };

    if (this.isLevelValid(BidPriceSaveModel)) {
      await this.props.saveItems(saveObject, this.resetScroll, +id);

      if (+id) {
        await this.props.getItems(id);
      }

      await this.props.resetPayload();

      if (+id) {
        await this.props.getBidPriceDetails(id);
      }

      this.setState({ isSaveButtonClicked: false });
      this.props.resetDirty();
    }
  };

  handleDateConflictDialog = () => {
    this.setState({
      showDateConflictModal: false,
    });
  };

  handleMaxDateDialog = () => {
    this.setState({
      showMaxBeginDateModal: false,
    });
  };
  handleBidPriceDialog = () => {
    this.setState({
      showBidPriceModal: false,
    });
  };

  setHeaderRowButtonState = buttonValue => {
    const {
      bidPriceDetailsData,
      originalBidPriceData,
      selectedBidRowIndex,
      getWarehouseWarning,
    } = this.props;
    if (this.state.headerInfo !== TabItemMaintenanceEnum.BidPrice) {
      this.handleSetHeaderTab(buttonValue);
      return;
    }
    //skip for new item (item id is 0 for new item)
    if (+this.props.match.params.id) {
      this.setState(
        {
          currentHeaderTab: buttonValue,
        },
        () => {
          const changedQtyPerUnit = isQtyPerUnitChanged(
            bidPriceDetailsData,
            originalBidPriceData,
            selectedBidRowIndex
          );
          if (changedQtyPerUnit) {
            const { QtyPerUnit, BidId } = bidPriceDetailsData.BidPriceDetails[
              selectedBidRowIndex
            ];
            if (+BidId) {
              this.setState(
                {
                  showTabSwitchModal: true,
                },
                () => {
                  getWarehouseWarning(
                    this.props.match.params.id,
                    BidId,
                    QtyPerUnit
                  );
                }
              );
            } else {
              this.handleSetHeaderTab(buttonValue);
            }
          } else {
            this.handleSetHeaderTab(buttonValue);
          }
        }
      );
    } else {
      this.handleSetHeaderTab(buttonValue);
    }
  };
  handleSetHeaderTab = buttonValue => {
    this.setState({
      headerInfo: buttonValue,
      showTabSwitchModal: false,
    });
  };
  handleWareHouseWarningForTabDialog = result => {
    const {
      selectedBidRowIndex,
      resetWarehouseWarning,
      clearControlInfo,
      updateBidPriceDetails,
      originalBidPriceData,
    } = this.props;
    clearControlInfo();
    if (result) {
      this.handleSetHeaderTab(this.state.currentHeaderTab);
    } else {
      const setPrevQtyPerUnitValue = true;
      const input = {
        newValue:
          originalBidPriceData[selectedBidRowIndex][BidPriceEnum.QtyPerUnit],
        prevValue:
          originalBidPriceData[selectedBidRowIndex][BidPriceEnum.QtyPerUnit],
        selectedIndex: selectedBidRowIndex,
        fieldName: BidPriceEnum.QtyPerUnit,
      };
      updateBidPriceDetails(input, setPrevQtyPerUnitValue);
    }
    resetWarehouseWarning();
    this.setState({
      showTabSwitchModal: false,
    });
  };
  handleWareHouseWarningForSaveDialog = result => {
    const {
      selectedBidRowIndex,
      resetWarehouseWarning,
      clearControlInfo,
      updateBidPriceDetails,
      originalBidPriceData,
    } = this.props;
    clearControlInfo();
    if (result) {
      this.handleOnSaveClick();
    } else {
      const setPrevQtyPerUnitValue = true;
      const input = {
        newValue:
          originalBidPriceData[selectedBidRowIndex][BidPriceEnum.QtyPerUnit],
        prevValue:
          originalBidPriceData[selectedBidRowIndex][BidPriceEnum.QtyPerUnit],
        selectedIndex: selectedBidRowIndex,
        fieldName: BidPriceEnum.QtyPerUnit,
      };
      updateBidPriceDetails(input, setPrevQtyPerUnitValue);
    }
    resetWarehouseWarning();
    this.setState({
      showSaveClickedModal: false,
    });
  };

  isLevelValid = payload => {
    let isValid = true;
    let index = 0;
    _.forEach(payload.BidPriceDetails, (bidItem, key) => {
      if (
        bidItem.BracketPricingDetails &&
        bidItem.BracketPricingDetails.length > 0 &&
        bidItem.BracketType !== BracketTypeEnum.None
      ) {
        _.forEach(bidItem.BracketPricingDetails, bracketPrice => {
          if (
            bracketPrice.ToBracket === '' ||
            (bracketPrice.ToBracket !== null &&
              bracketPrice.ToBracket <= bracketPrice.FromBracket)
          ) {
            bracketPrice.toError = true;
            isValid = false;
            index = key;
          }
          if (!bracketPrice.Price) {
            bracketPrice.priceError = true;
            isValid = false;
            index = key;
          }
        });
      } else {
        bidItem.BracketPricingDetails = [];
      }
    });
    if (!isValid) {
      this.props.updateGridFormFields(payload.BidPriceDetails[index], index);
    }
    return isValid;
  };
  render() {
    const {
      submitting,
      fetching,
      fetchingOnHands,
      loadingBidPriceDetails,
      warehouseWarning,
      beginDT,
      endDT,
    } = this.props;
    const { id } = this.props.match.params;
    const title = `${+id ? 'Edit' : 'Add'} - Item`;
    const isNew = !+id;
    const { headerInfo } = this.state;
    const wareHouseWarningBoolValue = getWareHouseWarningBooleanValue(
      warehouseWarning
    );

    return submitting ||
      fetching ||
      fetchingOnHands ||
      loadingBidPriceDetails ? (
      <LoadingPage />
    ) : (
      <Fragment>
        <Filter title={title} newRow={true}>
          <Grid>
            <Grid.Row>
              {isNew ? (
                <HeaderRowButtonComponent
                  headerRowButtons={NewItemHeaderRowButtons}
                  headerInfo={headerInfo}
                  setHeaderRowButtonState={this.setHeaderRowButtonState}
                />
              ) : (
                <HeaderRowButtonComponent
                  headerRowButtons={EditItemHeaderRowButtons}
                  headerInfo={headerInfo}
                  setHeaderRowButtonState={this.setHeaderRowButtonState}
                />
              )}
            </Grid.Row>
          </Grid>
        </Filter>
        <Main {...this.getMainProps()} shouldNotUsePageWidth>
          {isNew ? (
            <Fragment>
              {headerInfo === TabItemMaintenanceEnum.Details && (
                <ItemDetailsForm
                  loading={fetching}
                  isNew={isNew}
                  onSubmit={this.handleItemDetailSubmit}
                  id={'0'}
                  filterValues={this.state.itemDetailsValues}
                  handleItemDetailFieldChange={this.handleItemDetailFieldChange}
                  initialValues={INITIAL_VALUES}
                  isSaveButtonClicked={this.state.isSaveButtonClicked}
                />
              )}
              {headerInfo === TabItemMaintenanceEnum.BidPrice && (
                <BidPrice
                  onSubmit={this.handleItemBidPriceSubmit}
                  loading={fetching}
                  isNew={isNew}
                  id={id}
                  initialValues={this.props.initialValues}
                  handleItemDetailFieldChange={this.handleItemDetailFieldChange}
                  isSaveButtonClicked={this.state.isSaveButtonClicked}
                />
              )}
            </Fragment>
          ) : (
            <Fragment>
              {headerInfo === TabItemMaintenanceEnum.Details && (
                <ItemDetailsForm
                  loading={fetching}
                  onSubmit={this.handleItemDetailSubmit}
                  id={id}
                  isNew={isNew}
                  filterValues={this.state.itemDetailsValues}
                  handleItemDetailFieldChange={this.handleItemDetailFieldChange}
                  initialValues={getInitialValues(
                    this.props.bidPriceDetailsData,
                    this.props.itemDetails
                  )}
                  isSaveButtonClicked={this.state.isSaveButtonClicked}
                />
              )}
              {headerInfo === TabItemMaintenanceEnum.BidPrice && (
                <BidPrice
                  onSubmit={this.handleItemBidPriceSubmit}
                  loading={fetching}
                  isNew={isNew}
                  id={id}
                  initialValues={this.props.initialValues}
                  handleItemDetailFieldChange={this.handleItemDetailFieldChange}
                  isSaveButtonClicked={this.state.isSaveButtonClicked}
                />
              )}
              {headerInfo === TabItemMaintenanceEnum.FIFO && (
                <FIFO
                  initialValues={{
                    [FifoEnum.PrintOptions]: PrintGroupByTypeEnum.Item,
                    [FifoEnum.BeginDT]: moment()
                      .subtract(1, 'month')
                      .format(DATE_FORMAT_FOR_UI),
                    [FifoEnum.EndDT]: moment().format(DATE_FORMAT_FOR_UI),
                    [FifoEnum.SelectAll]: false,
                  }}
                  id={id}
                />
              )}
              {headerInfo === TabItemMaintenanceEnum.TransactionDetails && (
                <TransactionDetails
                  initialValues={{
                    [TransactionDetailsEnum.BeginDT]: beginDT
                      ? beginDT
                      : moment()
                          .subtract(1, 'month')
                          .format(DATE_FORMAT_FOR_UI),
                    [TransactionDetailsEnum.EndDT]: endDT
                      ? endDT
                      : moment().format(DATE_FORMAT_FOR_UI),
                    [TransactionDetailsEnum.Adjustment]: true,
                    [TransactionDetailsEnum.Order]: true,
                    [TransactionDetailsEnum.Physical]: true,
                    [TransactionDetailsEnum.Receipt]: true,
                    [TransactionDetailsEnum.Usage]: true,
                    [TransactionDetailsEnum.Transfer]: true,
                  }}
                  isNew={isNew}
                  id={id}
                />
              )}
            </Fragment>
          )}
        </Main>
        <NotificationDialog
          title={'Inventory'}
          showDialog={this.state.showDateConflictModal}
          message={
            'Bid Price Dates cannot overlap! Please make another date selection'
          }
          onOkClick={this.handleDateConflictDialog}
        />
        <NotificationDialog
          title={'Bid Price Begin Date Validation'}
          showDialog={this.state.showMaxBeginDateModal}
          message={
            'Bid Price Begin Date must be less than or equal to Bid Price End Date.'
          }
          onOkClick={this.handleMaxDateDialog}
        />
        <NotificationDialog
          title={'Inventory'}
          showDialog={this.state.showBidPriceModal}
          message={
            'Item must have at least one Bid Price. Please add new Bid Price.'
          }
          onOkClick={this.handleBidPriceDialog}
        />
        <YesNoDialog
          showDialog={
            this.state.showSaveClickedModal && wareHouseWarningBoolValue
          }
          title="Inventory"
          question={warehouseWarning}
          yesCallback={() => {
            this.handleWareHouseWarningForSaveDialog(true);
          }}
          noCallback={() => {
            this.handleWareHouseWarningForSaveDialog(false);
          }}
        />
        <YesNoDialog
          showDialog={
            this.state.showTabSwitchModal && wareHouseWarningBoolValue
          }
          title="Inventory"
          question={warehouseWarning}
          yesCallback={() => {
            this.handleWareHouseWarningForTabDialog(true);
          }}
          noCallback={() => {
            this.handleWareHouseWarningForTabDialog(false);
          }}
        />
      </Fragment>
    );
  }
}

const bidPriceSelector = formValueSelector(ITEM_MAINTENANCE_DETAIL_FORM_NAME);
const transactionDetailSelector = formValueSelector(
  ITEM_MAINTENANCE_TRANSACTION_DETAILS_FORM_NAME
);
const mapStateToProps = (state, ownProps) => {
  ownProps.setPageLevelDirty(
    getIsDirty(ITEM_MAINTENANCE_DETAIL_FORM_NAME)(state) ||
      getIsDirty(ITEM_MAINTENANCE_BID_PRICE_FORM_NAME)(state)
  );

  const {
    ItemMaintenanceState: {
      itemListing,
      addEditItem,
      updateBidPriceDetails: {
        bidPriceDetailsLoadingError,
        isSubmitting,
        warehouseWarning,
        deletedBidIds,
        bidPriceDetailsData,
        originalBidPriceData,
        loadingBidPriceDetails,
        controlInfoLoadingError,
        submitError,
        warehouseWarningLoadingError,
        loadingWarehouseWarning,
      },
    },
    CommonState: { gridPreference, filters },
  } = state;

  return {
    fetching: itemListing.fetching,
    itemDetails: itemListing.itemDetails,
    selectedBidRowIndex: itemListing.selectedBidRowIndex,
    submitted: addEditItem.submitted,
    submitError: addEditItem.submitError,
    submittingItemDetails: addEditItem.submitting,
    fetchFifoItemsError: addEditItem.fetchFifoItemsError,
    fetchingBidError: addEditItem.fetchingBidError,
    fetchingOnHandsError: addEditItem.fetchingOnHandsError,
    fetchingTransactionError: addEditItem.fetchingTransactionError,
    fetchingAltItemsError: addEditItem.fetchingAltItemsError,
    gridPreferenceSubmitting: gridPreference.isSubmitting,
    gridPreferenceSubmitError: gridPreference.submitError,
    itemDetailsError: itemListing.itemDetailsError,
    QtyPerUnit: bidPriceSelector(state, [BidPriceEnum.QtyPerUnit]),
    ItemId: bidPriceSelector(state, [UpdateBidPriceDetailsEnum.ItemId]),
    BidId: bidPriceSelector(state, [UpdateBidPriceDetailsEnum.BidId]),
    fetchingOnHands: addEditItem.fetchingOnHands,
    bidGroupDataError: filters.bidGroupDataError,
    itemGroupDataError: filters.itemGroupDataError,
    acctCategoryDataError: filters.acctCategoryDataError,
    vendorDataError: filters.vendorDataError,
    taxGroupSetupError: state.TaxGroupSetupState.taxGroupSetupError,
    allTableStates: getTableStates(state),
    printError: addEditItem.printError,
    loadingBidPriceDetails,
    isSubmitting,
    warehouseWarning,
    deletedBidIds,
    bidPriceDetailsData,
    originalBidPriceData,
    itemDetailErrors: getFormSyncErrors(ITEM_MAINTENANCE_DETAIL_FORM_NAME)(
      state
    ),
    itemDetailValues: getFormValues(ITEM_MAINTENANCE_DETAIL_FORM_NAME)(state),
    itemBidPriceErrors: getFormSyncErrors(ITEM_MAINTENANCE_BID_PRICE_FORM_NAME)(
      state
    ),
    itemBidPriceValues: getFormValues(ITEM_MAINTENANCE_BID_PRICE_FORM_NAME)(
      state
    ),
    bidPriceDetailsLoadingError,
    controlInfoLoadingError,
    bidPriceSubmitError: submitError,
    warehouseWarningLoadingError,
    loadingWarehouseWarning,
    usage: transactionDetailSelector(state, TransactionDetailsEnum.Usage),
    beginDT: transactionDetailSelector(state, TransactionDetailsEnum.BeginDT),
    endDT: transactionDetailSelector(state, TransactionDetailsEnum.EndDT),
    adjustment: transactionDetailSelector(
      state,
      TransactionDetailsEnum.Adjustment
    ),
    order: transactionDetailSelector(state, TransactionDetailsEnum.Order),
    physical: transactionDetailSelector(state, TransactionDetailsEnum.Physical),
    receipt: transactionDetailSelector(state, TransactionDetailsEnum.Receipt),
    transfer: transactionDetailSelector(state, TransactionDetailsEnum.Transfer),
    printLoading: addEditItem.printLoading,
  };
};

const mapDispatchToProps = {
  saveItems,
  submitForm,
  clearError,
  clearGridPreferenceSubmitError,
  resetForm,
  getBidPriceDetails,
  ...actions,
  getAcctCategoryForCurrentSite,
  getBidGroupForCurrentSite,
  getItemGroupForCurrentSite,
  getVendorForCurrentSite,
  getTaxGroupSetup,
  getItems,
  setTableStates,
  updateSelectedRowIndex,
  getControlInfo,
  resetBidPriceData,
  resetPayload,
  clearBidPriceData,
  resetDirty,
  clearBidPriceError,
  updateGridFormFields,
  updateBidPriceDetails,
  resetWarehouseWarning,
  clearControlInfo,
  getWarehouseWarning,
};
export const AddEditItemModal = connect(
  mapStateToProps,
  mapDispatchToProps
)(AddEditModal);



// WEBPACK FOOTER //
// ./src/pages/inventory/itemmaintenance/subpages/AddEditItem.js